import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from "@reduxjs/toolkit";
const initialState = {
  serviceList: {
    preist: {},       // { eventID: { providerID, ... } }
    catering: {},     // { eventID: [{ providerID, mapping_id, ... }] }
    tenthouse: {}     // { eventID: { providerID, ... } }
  },
  syncing: false,
  syncError: null,
  refreshKey: 0 
};

export const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const { 
        serviceType, 
        eventID, 
        providerID, 
        service_id,
        price,
        discountprice,
        discountvalidupto,
        quantity, 
        mapping_id,
        cart_id,
        is_checked_out,
        package_id 
      } = action.payload;

      // Validation
      if (!serviceType || !eventID || !providerID) {
        console.warn('Missing required fields');
        return;
      }

      // Initialize service type if not exists
      if (!state.serviceList[serviceType]) {
        state.serviceList[serviceType] = {};
      }
       // In cartSlice.js - Update the addToCart reducer
        if (serviceType === 'preist') {
          // Check if there's already a priest for this event
          const existing = state.serviceList.preist[eventID];

          // If a priest already exists for this event, show warning/error
          
          if (existing) {                      
            console.warn(`Replacing priest for event ${eventID}. Provider ${existing.providerID} -> ${providerID}`);
          }
        
          state.serviceList.preist[eventID] = {
            providerID,
            service_id,
            cart_id,
            price,
            discountprice,
            discountvalidupto,
            quantity,
            package_id: package_id || null,
            is_checked_out 
          };
        }
      // Handle catering (array-based)
      if (serviceType === 'catering') {
        if (!state.serviceList.catering[eventID]) {
          state.serviceList.catering[eventID] = []; // Initialize as array
        }

        // Check if provider+service+mapping already exists
        const exists = state.serviceList.catering[eventID].some(item => 
          item.providerID === providerID && 
          (mapping_id ? item.mapping_id === mapping_id : true)
        );

        if (!exists) {
          state.serviceList.catering[eventID].push({
            providerID,
            service_id,
              
            mapping_id,
            is_checked_out 
          });
        }
      } 
      // Handle preist/tenthouse (single provider per event)
      else {
        const existing = state.serviceList[serviceType][eventID];
        
        // Prevent duplicate providers
        if (existing?.providerID === providerID) {
          console.warn(`Provider ${providerID} already exists for ${serviceType}`);
          return;
        }

        // For tenthouse, check if provider exists in ANY event
        // if (serviceType === 'tenthouse') {
        //   const providerInOtherEvent = Object.values(state.serviceList.tenthouse)
        //     .some(item => item?.providerID === providerID);
          
        //   if (providerInOtherEvent) {
        //     console.warn(`Tenthouse provider ${providerID} already booked`);
        //     return;
        //   }
        // }

        state.serviceList[serviceType][eventID] = {
          providerID,
          service_id,
          cart_id,
          price,
          discountprice,
          discountvalidupto,
          quantity,
          mapping_id: mapping_id || null,          
          is_checked_out 
        };
      }
    },
    triggerRefresh: (state) => {
      state.refreshKey += 1;
    },

removeFromCart: (state, action) => {
  const { serviceType, eventID, providerID, mapping_id } = action.payload;

  if (!state.serviceList[serviceType]?.[eventID]) return;

  // Handle catering (array-based)
  if (serviceType === 'catering') {
    const cateringItems = state.serviceList.catering[eventID];

    const itemsArray = Array.isArray(cateringItems)
      ? cateringItems
      : [cateringItems].filter(Boolean);

    // Filter items using both providerID and mapping_id
    state.serviceList.catering[eventID] = itemsArray.filter(item =>
      !(item.providerID === providerID && item.mapping_id === mapping_id)
    );

    // Cleanup empty arrays
    if (state.serviceList.catering[eventID].length === 0) {
      delete state.serviceList.catering[eventID];
    }
  } else {
    // preist/tenthouse
    if (state.serviceList[serviceType][eventID]?.providerID === providerID) {
      delete state.serviceList[serviceType][eventID];
    }
  }
}
,
    removePreistByEventId: (state, action) => {
  const { eventID } = action.payload;
  if (state.serviceList.preist[eventID]) {
    delete state.serviceList.preist[eventID];
  }
},
removeTenthouseByEventId: (state, action) => {
  const { eventID } = action.payload;
  if (state.serviceList.tenthouse[eventID]) {
    delete state.serviceList.tenthouse[eventID];
  }
},


    clearCart: (state) => {
      state.serviceList = { preist: {}, catering: {}, tenthouse: {} };
    },
    
    clearPreistCart: (state) => {
      state.serviceList.preist = {};
    },
    
    clearTenthouseCart: (state) => {
      state.serviceList.tenthouse = {};
    },

    clearCateringCart: (state) => {
      state.serviceList.catering = {};
    }
  }
});


export const isProviderAdded = (state, eventID, providerID, serviceID, mapping_id = null) => {
  const serviceMap = {
    7: 'preist',
    8: 'tenthouse',
    9: 'catering'
  };

  const serviceType = serviceMap[serviceID];
  if (!serviceType) return false;
  const serviceData = state.cart.serviceList[serviceType];
  // console.log("checking isProviderAdded",serviceType, eventID, providerID, serviceID, mapping_id,serviceData)
  if (!serviceData || !serviceData[eventID]) return false;

  if (serviceType === 'catering') {

    const itemsArray = Array.isArray(serviceData[eventID]) 
      ? serviceData[eventID] 
      : [serviceData[eventID]].filter(Boolean);     
   const match = itemsArray.some(item =>
        item.providerID == providerID && item.mapping_id == mapping_id
      );

      if (match) return true;
  } else {
    const providerData = serviceData[eventID];
    if (!providerData) return false;

    return providerData.providerID === providerID;
  }
};

export const checkisProviderAdded = (state, eventID, providerID, serviceID, mapping_id = null) => {
  const serviceMap = {
    7: 'preist',
    8: 'tenthouse',
    9: 'catering'
  };

  const serviceType = serviceMap[serviceID];
  if (!serviceType) return false;
  // console.log("checking checkisProviderAdded",serviceType, eventID, providerID, serviceID, mapping_id)
  const serviceData = state.cart.serviceList[serviceType];
  if (!serviceData || !serviceData[eventID]) return false;

  if (serviceType === 'catering') {
    const itemsArray = Array.isArray(serviceData[eventID]) 
      ? serviceData[eventID] 
      : [serviceData[eventID]].filter(Boolean);
    
    return itemsArray.some(item => 
      item.providerID === providerID && 
      (mapping_id ? item.mapping_id === mapping_id : true)
    );
  } else if (serviceType === 'preist') {
    
    return Boolean(serviceData[eventID]);
  } 
   else if (serviceType === 'tenthouse') {    
    return Boolean(serviceData[eventID])
  }
    else {
    const providerData = serviceData[eventID];
    if (!providerData) return false;

    return providerData.providerID === providerID;
  }
};
// selector/helper
export const isProviderAddedForEventTabs = (state, eventID, serviceID) => {
  const serviceMap = {
    7: 'preist',
    8: 'tenthouse',
    9: 'catering'
  };

  const serviceType = serviceMap[serviceID];
  if (!serviceType) return false;

  const serviceData = state.cart.serviceList[serviceType];
  // console.log("serviceData",serviceData)
  if (!serviceData) return false;

  // Catering = array, Priest/Tenthouse = object
  if (serviceType === "catering") {
    return Array.isArray(serviceData[eventID]) && serviceData[eventID].length > 0;
  } else {
    return Boolean(serviceData[eventID]); // object check
  }
};

export const getCartId = (state, eventID, serviceID, mapping_id = null) => {
  const serviceMap = {
    7: 'preist',
    8: 'tenthouse',
    9: 'catering'
  };

  const serviceType = serviceMap[serviceID];
  if (!serviceType) return null;

  const serviceData = state.cart.serviceList[serviceType];
  if (!serviceData || !serviceData[eventID]) return null;

  // Handle catering (array)
  if (serviceType === 'catering') {
    const itemsArray = Array.isArray(serviceData[eventID]) 
      ? serviceData[eventID] 
      : [serviceData[eventID]].filter(Boolean);
    
    const item = mapping_id 
      ? itemsArray.find(item => item.mapping_id === mapping_id)
      : itemsArray[0];
      
    return item?.cart_id;
  } 
  // Handle preist/tenthouse (single object)
  else {
    return serviceData[eventID].cart_id;
  }
};

export const { 
  addToCart, 
  removeFromCart, 
  clearCart,
  clearPreistCart,
  clearTenthouseCart,
  clearCateringCart,
  triggerRefresh,
  removePreistByEventId,
  removeTenthouseByEventId,
} = cartSlice.actions;

export default cartSlice.reducer;
export const selectCartData = (state) => state.cart.items; // or state.cart depending on your structure
export const getTenthouseProviderID = (state, eventID) => {
  const tenthouseData = state.cart.serviceList.tenthouse[eventID];
  return tenthouseData?.providerID || null;
};


export const makeGetEventServiceIdentifiers = () =>
  createSelector(
    [(state) => state.cart.serviceList, (_, eventID) => eventID],
    (serviceList, eventID) => {
      const preist = serviceList.preist?.[eventID] || {};
      const tenthouse = serviceList.tenthouse?.[eventID] || {};
      const catering = serviceList.catering?.[eventID] || [];

      return {
        priestCartId: preist.cart_id || null,
        priestProviderId: preist.providerID || null,
        tenthouseProviderId: tenthouse.providerID || null,
        catering: Array.isArray(catering)
          ? catering.map(c => ({
              mappingId: c.mapping_id,
              providerId: c.providerID,
            }))
          : [],
      };
    }
  );

// Helper to check if a service for an event is checked out
export const isServiceCheckedOut = (state, eventID, serviceID, mapping_id = null) => {
  const serviceMap = {
    7: 'preist',
    8: 'tenthouse',
    9: 'catering'
  };

  const serviceType = serviceMap[serviceID];
  if (!serviceType) return false;

  const serviceData = state.cart.serviceList[serviceType];
  if (!serviceData || !serviceData[eventID]) return false;

  if (serviceType === 'catering') {
    const itemsArray = Array.isArray(serviceData[eventID])
      ? serviceData[eventID]
      : [serviceData[eventID]].filter(Boolean);

    const item = mapping_id
      ? itemsArray.find(i => i.mapping_id === mapping_id)
      : itemsArray[0];

    return Boolean(item?.is_checked_out);
  } else {
    return Boolean(serviceData[eventID]?.is_checked_out);
  }
};

// selector/helper to fetch all catering items for an event
export const getCateringItemsByEventId = (state, eventID) => {
  const cateringData = state.cart.serviceList.catering?.[eventID];
  if (!cateringData) return [];

  return Array.isArray(cateringData) ? cateringData : [cateringData];
};
